// import Submit from '../Submit';

import styled from 'styled-components'

import onedriveIcon from '../../assets/onedrive-icon.svg'

const Button = styled.div`
    font-size: 14px;
    line-height: 16px;
    color: #606060;

    display: flex;
    flex-direction: column;
    width: 124px;
    height: 92px;

    align-items: center;
    justify-content: center;

    background: rgba(255, 255, 255, 0.6);
    border-radius: 8px;

    cursor: pointer;
    background: rgba(255, 255, 255, 0.6);

    transition: background .2s;
    z-index: 1;

    &:hover {
        background: #F4F3F4;
    }

    &:first-child {
        margin-left: 0;
    }

    @media (min-width: 480px) {
        width: 96px;
    }
`
Button.displayName = 'Service-Button'

const Icon = styled.div`
    width: 48px;
    height: 48px;
    background-image: url(${onedriveIcon});
`
Icon.displayName = 'Service-Icon'


type Props = {
    callback: (url: string) => void,
};

const OnedriveButton = ({ callback }: Props) => {
    function launchOneDrivePicker(){
        var odOptions = {
            clientId: "b5e0f390-19ee-4cf6-af13-1ac4fc3a3315",
            action: "download",
            filter: "folder,.pdf",
            success: (files: any) => {
                console.log(files.value[0]['@microsoft.graph.downloadUrl']);
                callback(files.value[0]['@microsoft.graph.downloadUrl']);
            }
        } 
        // @ts-ignore
        window.OneDrive.open(odOptions);
    }

    // return <Submit onClick={()=> {
    //     // @ts-ignore
    //     if (window.OneDrive !== undefined) {
    //         // @ts-ignore
    //         launchOneDrivePicker();
    //     }
    // }}>
    //     Connect to OneDrive
    // </Submit>

    return <Button onClick={() => {
        // @ts-ignore
        if (window.OneDrive !== undefined) {
            // @ts-ignore
            launchOneDrivePicker();
        }
    }}>
        <Icon />
        One Drive
    </Button>
}

export default OnedriveButton
